var React = require('react');

function ChevronLeft24x24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 3.19483L9.65784 0.5L21 12L9.65785 23.5L7 20.8052L15.6843 12L7 3.19483Z","transform":"translate(24 24) rotate(180)"}));
}

ChevronLeft24x24.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = ChevronLeft24x24;

ChevronLeft24x24.default = ChevronLeft24x24;
